module.exports = __webpack_public_path__ + "static/media/Game6x6.f38b56a7.png";